import {
  ChangePasswordRequestBodyT,
  SporopayKeyRequestBodyT,
} from '@/support/types';

export default {
  // GLOBAL
  getClientInfo: {
    method: 'GET',
    apiUrl: 'my-security/api/client/info',

    headers: {
      Authorization: '',
    },

    messageBody: <SporopayKeyRequestBodyT>{
      accountId: '',
      newSporopayKey: '',
    },
  },

  invalidateToken: {
    method: 'DELETE',
    apiUrl: 'my-security/api/auth/token/invalidate',

    headers: {
      Authorization: '',
    },
  },

  refreshToken: {
    method: 'GET',
    apiUrl: 'my-security/api/heartbeat',

    headers: {
      Authorization: 'authToken',
    },
  },

  beanCounter: {
    method: 'POST',
    apiUrl: 'beancounter/events/async',

    headers: {
      Authorization: 'authToken',
      'Content-Type': 'application/json',
    },

    // two versions here. start process and page walking
    messageBody: {
      type: 'page',
      source: 'ggo-store',
      name: 'eventValue1', // params or route
      data: {
        userAgent: navigator.userAgent,
      },
    },
  },

  postStartProcess: {
    method: 'POST',
    apiUrl: 'my-security/api/proc/startprocess/MTokenManagement/crm',

    requestBody: {
      variables: {
        mTokenManagementStartData: {
          type: 'Object',
          value: '${startProcessConfig}', // eslint-disable-line no-template-curly-in-string
          valueInfo: {
            objectTypeName:
              'sk.slsp.omnichannel.crm.processmodel.mtokenmanagement.MTokenManagementStartData',
            serializationDataFormat: 'application/json',
          },
        },
      },
    },
  },

  getGetNextTask: {
    method: 'GET',
    apiUrl: 'my-security/api/proc/getnexttask/',

    headers: {
      Authorization: '',
    },
  },

  postCompleteTask: {
    method: 'POST',
    apiUrl: 'my-security/api/proc/completetask/',

    headers: {
      Authorization: '',
      'X-Internal-Id': 'pid',
      'X-Application-Id': 'crm',
    },
  },

  // CHANGE PASSOWORD
  changePassword: {
    method: 'PUT',
    apiUrl: 'my-security/api/auth/password',

    headers: {
      Authorization: '',
    },

    messageBody: <ChangePasswordRequestBodyT>{
      oldPassword: '',
      newPassword: '',
    },
  },

  // ALIAS
  getAliasName: {
    method: 'GET',
    apiUrl: 'my-security/api/client/alias',

    headers: {
      Authorization: '',
    },
  },

  setAliasName: {
    method: 'POST',
    apiUrl: 'my-security/api/alias',

    headers: {
      Authorization: '',
    },

    messageBody: {
      oldAlias: '',
      newAlias: '',
    },
  },

  // SPOROPAY KEY
  getSporopayKeyAccounts: {
    method: 'GET',
    apiUrl: 'my-security/api/accounts',

    headers: {
      Authorization: '',
    },
  },

  sendSporopayKeyData: {
    method: 'PUT',
    apiUrl: 'my-security/api/merchantkey',

    headers: {
      Authorization: '',
    },

    messageBody: <SporopayKeyRequestBodyT>{
      accountId: '',
      newSporopayKey: '',
    },
  },

  // AUTH TOOLS
  stList: {
    method: 'GET',
    apiUrl: 'my-security/api/security-tools',

    headers: {
      Authorization: '',
    },
  },

  // BLOCK AUTH TOOL
  postAuthToolBlock: {
    method: 'PUT',
    apiUrl: 'my-security/api/security-tools/${id}/state', // eslint-disable-line no-template-curly-in-string

    messageBody: {
      state: '${state}', // eslint-disable-line no-template-curly-in-string
    },
  },

  // SIGNING
  // postSignIdMtoken: {

  //     method: 'POST',
  //     apiUrl: 'my-security/api/mtoken/sign',

  //     headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: 'authToken',
  //     },

  //     messageBody: {
  //         operationCode: 'from task details',
  //         taskId: 'from task details',
  //     },
  // },

  // signingStep1Mtoken: {

  //     method: 'GET',
  //     apiUrl: 'my-security/api/mtoken/sign/',

  //     headers: {
  //         Authorization: 'authToken',
  //     },
  // },

  // signingStep2Mtoken: {

  //     method: 'POST',
  //     apiUrl: 'my-security/api/mtoken/sign/',

  //     headers: {
  //         Authorization: 'authToken',
  //     },

  //     messageBody: {
  //         authorizationType: 'authType',
  //     },
  // },

  // signingStep3Mtoken: {

  //     method: 'PUT',
  //     apiUrl: 'my-security/api/mtoken/sign/',

  //     headers: {
  //         Authorization: 'authToken',
  //     },

  //     messageBody: {
  //         variableName: 'mTokenCreateData',
  //         variables: {
  //             mTokenCreateData: {
  //                 type: 'Object',
  //                 // eslint-disable-next-line
  //                 value: '{\"action\":\"NEXT\",\"signature\":null}',
  //                 valueInfo: {
  //                     objectTypeName: 'sk.slsp.omnichannel.crm.processmodel.mtokenmanagement.MTokenCreateData',
  //                     serializationDataFormat: 'application/json',
  //                 },
  //             },
  //         },
  //         authorizationType: 'SMS',
  //         oneTimePassword: 'otp',
  //     },
  // },

  // TPP
  postConsentList: {
    method: 'POST',
    apiUrl: 'my-security/api/tpp/consentlist',

    headers: {
      Authorization: 'authtoken',
    },

    messageBody: {
      consentStatus: null, // Enum: received, rejected, valid, revokedByPsu, expired, terminatedByTpp
      applicationId: null, // TPP application Identifier
    },
  },

  deleteConsent: {
    method: 'DELETE',
    apiUrl: 'my-security/api/tpp/consents/', // add consent id to end of url

    headers: {
      Authorization: 'authtoken',
    },
  },

  postFilterSearch: {
    method: 'POST',
    apiUrl: 'my-security/api/tpp/apicalls/search',

    headers: {
      Authorization: 'authtoken',
    },

    // message body interface FilterRequestI
  },

  // SMS VALIDATION
  getValidateUrl: {
    method: 'GET',
    apiUrl:
      'urlshortener/api/slsplink/validate-url?hash=${hash}&phoneNumber=${phoneNumber}', // eslint-disable-line no-template-curly-in-string
  },

  // SIGNING FOR EPIN
  // GET SIGN ID
  getSignId: {
    method: 'POST',
    apiUrl: 'my-security/api/epin/sign',
    headers: {
      Authorization: 'string',
    },
  },
  // STEP 1
  signingStep1: {
    method: 'GET',
    apiUrl: 'my-security/api/epin/sign/${transactionId}', // eslint-disable-line no-template-curly-in-string
    headers: {
      Authorization: 'string',
    },
  },
  // STEP 2
  signingStep2: {
    method: 'POST',
    apiUrl: 'my-security/api/epin/sign/${transactionId}', // eslint-disable-line no-template-curly-in-string
    headers: {
      Authorization: 'string',
    },
  },
  // POLLING MTOKEN
  signingPollMToken: {
    method: 'GET',
    apiUrl: '${url}', // eslint-disable-line no-template-curly-in-string
    headers: {
      Authorization: 'string',
    },
  },
  // STEP 3
  signingStep3: {
    method: 'PUT',
    apiUrl: 'my-security/api/epin/sign/${transactionId}', // eslint-disable-line no-template-curly-in-string
    headers: {
      Authorization: 'string',
    },
  },
};
